import { combineReducers } from "redux"

// Front
import Client from "./client/reducer"
import Common from "./common/reducer"

const rootReducer = combineReducers({
  Client,
  Common
})

export default rootReducer
